"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesStats$ = exports.PropertiesStats$outboundSchema = exports.PropertiesStats$inboundSchema = void 0;
exports.propertiesStatsToJSON = propertiesStatsToJSON;
exports.propertiesStatsFromJSON = propertiesStatsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiesstatsestimatedvalueswrapper_js_1 = require("./propertiesstatsestimatedvalueswrapper.js");
/** @internal */
exports.PropertiesStats$inboundSchema = z.object({
    estimated_rental_value: z.number().int(),
    estimated_values: propertiesstatsestimatedvalueswrapper_js_1.PropertiesStatsEstimatedValuesWrapper$inboundSchema,
    internal_area_square_foot: z.number().int(),
    price_per_square_foot: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "estimated_rental_value": "estimatedRentalValue",
        "estimated_values": "estimatedValues",
        "internal_area_square_foot": "internalAreaSquareFoot",
        "price_per_square_foot": "pricePerSquareFoot",
    });
});
/** @internal */
exports.PropertiesStats$outboundSchema = z.object({
    estimatedRentalValue: z.number().int(),
    estimatedValues: propertiesstatsestimatedvalueswrapper_js_1.PropertiesStatsEstimatedValuesWrapper$outboundSchema,
    internalAreaSquareFoot: z.number().int(),
    pricePerSquareFoot: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        estimatedRentalValue: "estimated_rental_value",
        estimatedValues: "estimated_values",
        internalAreaSquareFoot: "internal_area_square_foot",
        pricePerSquareFoot: "price_per_square_foot",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesStats$;
(function (PropertiesStats$) {
    /** @deprecated use `PropertiesStats$inboundSchema` instead. */
    PropertiesStats$.inboundSchema = exports.PropertiesStats$inboundSchema;
    /** @deprecated use `PropertiesStats$outboundSchema` instead. */
    PropertiesStats$.outboundSchema = exports.PropertiesStats$outboundSchema;
})(PropertiesStats$ || (exports.PropertiesStats$ = PropertiesStats$ = {}));
function propertiesStatsToJSON(propertiesStats) {
    return JSON.stringify(exports.PropertiesStats$outboundSchema.parse(propertiesStats));
}
function propertiesStatsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesStats$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesStats' from JSON`);
}
//# sourceMappingURL=propertiesstats.js.map